import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { useSettingsStore } from "../../../features/settings/services/useSettingsStore";
import { AppConfig } from "../../AppConfig";
import "./AppFooter.css";

export const REGEX_PHONEFIX = /[\s-]+/g;

function AppFooter() {
  const { t } = useTranslation();
  const settingsStore = useSettingsStore();

  const providerAppointmentPhoneTitle = settingsStore.legacySettings
    ?.providerAppointmentPhone
    ? (settingsStore.legacySettings?.providerPhone
        ? t("Home.Appointments.PhoneTitle") + ": "
        : ""
      ).toUpperCase()
    : "";

  const providerAppointmentPhone =
    settingsStore.legacySettings?.providerAppointmentPhone ?? "";

  const providerAppointmentPhoneLink =
    "tel:" +
    settingsStore.legacySettings?.providerAppointmentPhone?.replace(
      REGEX_PHONEFIX,
      ""
    );

  return (
    <div className="appFooter flex p-1 gap-1 justify-content-center">
      {!providerAppointmentPhone && (
        <div className="font-bold text-left">
          <span>{settingsStore.legacySettings?.providerName}</span>{" "}
        </div>
      )}

      {providerAppointmentPhone && (
        <div className="font-bold">
          <div className="flex flex-column align-items-center md:flex-row gap-1 md:gap-3">
            <Button
              className="font-bold text-lg shadow-3"
              onClick={() => {
                window.open(providerAppointmentPhoneLink, "_blank");
              }}
            >
              <div className="flex flex-column gap-1">
                <span>{providerAppointmentPhoneTitle}</span>
                <div className="flex justify-content-center align-items-center gap-2">
                  <i className="pi pi-phone"></i>
                  <span>{providerAppointmentPhone}</span>
                </div>
              </div>
            </Button>
          </div>
        </div>
      )}

      {!providerAppointmentPhone && (
        <div className="font-bold text-left">
          <span>{AppConfig.titleVersion}</span>{" "}
        </div>
      )}
    </div>
  );
}

export default AppFooter;
